import { defineComponent as o, openBlock as t, createBlock as l, unref as r, mergeProps as v, withCtx as m, createElementVNode as h } from "vue";
import { RevIcon as p } from "@ds/components/Icon";
const s = /* @__PURE__ */ o({
  name: "IconCellSignal",
  __name: "IconCellSignal",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const n = a;
    return (i, e) => (t(), l(r(p), v(n, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        h("path", {
          "fill-rule": "evenodd",
          d: "M17.5 3.25a1.25 1.25 0 0 0-1.25 1.25v15a1.25 1.25 0 0 0 1.25 1.25h3a1.25 1.25 0 0 0 1.25-1.25v-15a1.25 1.25 0 0 0-1.25-1.25h-3m.25 16V4.75h2.5v14.5h-2.5M9.25 8.5a1.25 1.25 0 0 1 1.25-1.25h3a1.25 1.25 0 0 1 1.25 1.25v11a1.25 1.25 0 0 1-1.25 1.25h-3a1.25 1.25 0 0 1-1.25-1.25v-11m1.5.25v10.5h2.5V8.75h-2.5m-8.5 3.75a1.25 1.25 0 0 1 1.25-1.25h3a1.25 1.25 0 0 1 1.25 1.25v7a1.25 1.25 0 0 1-1.25 1.25h-3a1.25 1.25 0 0 1-1.25-1.25v-7m1.5.25v6.5h2.5v-6.5h-2.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  s as default
};
